export default __webpack_public_path__ + "static/media/close_icon.64683e25.svg";